var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup131(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 45,
    viewBox: "0 0 53 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(-50 -141)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(50 141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45-2",
    "data-name": "Ellipse 45",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(62 141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45-3",
    "data-name": "Ellipse 45",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(74 141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45-4",
    "data-name": "Ellipse 45",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(86 141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45-5",
    "data-name": "Ellipse 45",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(98 141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45-6",
    "data-name": "Ellipse 45",
    cx: 2.5,
    cy: 3,
    rx: 2.5,
    ry: 3,
    transform: "translate(50 154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45-7",
    "data-name": "Ellipse 45",
    cx: 2.5,
    cy: 3,
    rx: 2.5,
    ry: 3,
    transform: "translate(62 154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45-8",
    "data-name": "Ellipse 45",
    cx: 2.5,
    cy: 3,
    rx: 2.5,
    ry: 3,
    transform: "translate(74 154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45-9",
    "data-name": "Ellipse 45",
    cx: 2.5,
    cy: 3,
    rx: 2.5,
    ry: 3,
    transform: "translate(86 154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45-10",
    "data-name": "Ellipse 45",
    cx: 2.5,
    cy: 3,
    rx: 2.5,
    ry: 3,
    transform: "translate(98 154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45-11",
    "data-name": "Ellipse 45",
    cx: 2.5,
    cy: 2,
    rx: 2.5,
    ry: 2,
    transform: "translate(50 168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45-12",
    "data-name": "Ellipse 45",
    cx: 2.5,
    cy: 2,
    rx: 2.5,
    ry: 2,
    transform: "translate(62 168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45-13",
    "data-name": "Ellipse 45",
    cx: 2.5,
    cy: 2,
    rx: 2.5,
    ry: 2,
    transform: "translate(74 168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45-14",
    "data-name": "Ellipse 45",
    cx: 2.5,
    cy: 2,
    rx: 2.5,
    ry: 2,
    transform: "translate(86 168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45-15",
    "data-name": "Ellipse 45",
    cx: 2.5,
    cy: 2,
    rx: 2.5,
    ry: 2,
    transform: "translate(98 168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45-16",
    "data-name": "Ellipse 45",
    cx: 2.5,
    cy: 3,
    rx: 2.5,
    ry: 3,
    transform: "translate(50 180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45-17",
    "data-name": "Ellipse 45",
    cx: 2.5,
    cy: 3,
    rx: 2.5,
    ry: 3,
    transform: "translate(62 180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45-18",
    "data-name": "Ellipse 45",
    cx: 2.5,
    cy: 3,
    rx: 2.5,
    ry: 3,
    transform: "translate(74 180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45-19",
    "data-name": "Ellipse 45",
    cx: 2.5,
    cy: 3,
    rx: 2.5,
    ry: 3,
    transform: "translate(86 180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45-20",
    "data-name": "Ellipse 45",
    cx: 2.5,
    cy: 3,
    rx: 2.5,
    ry: 3,
    transform: "translate(98 180)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup131);
export default __webpack_public_path__ + "static/media/Group 131.e694479e97aeb484d8c0cdf1466b3b3a.svg";
export { ForwardRef as ReactComponent };